type BatchReferenceLine = {
  id: string;
  createdAt: string | Date;
  batch: { referenceLineId: string | null } | null;
};

const toTimestamp = (createdAt: string | Date) => new Date(createdAt).getTime();

const byOldestFirst = (left: BatchReferenceLine, right: BatchReferenceLine) => {
  const createdAtDelta = toTimestamp(left.createdAt) - toTimestamp(right.createdAt);
  if (createdAtDelta !== 0) {
    return createdAtDelta;
  }

  return left.id.localeCompare(right.id);
};

export const getBatchReferenceLineId = (linesInBatch: BatchReferenceLine[]): string | null => {
  const sortedLines = [...linesInBatch].sort(byOldestFirst);
  const referenceLineId = sortedLines[0]?.batch?.referenceLineId;
  const isReferenceInBatch = sortedLines.some((line) => line.id === referenceLineId);

  return (isReferenceInBatch ? referenceLineId : sortedLines[0]?.id) ?? null;
};
